/** Prefijo del `id` de cada cabecera-disparador (enlaza `aria-labelledby`). */
export const TRIGGER_ID_PREFIX = 'accordion-trigger-'

/** Prefijo del `id` de cada panel-región (enlaza `aria-controls`). */
export const PANEL_ID_PREFIX = 'accordion-panel-'

/** Tamaño en px del chevron de la cabecera. */
export const CHEVRON_ICON_SIZE = 16
